

import { Component, Vue, Watch, Prop, ProvideReactive } from "vue-property-decorator"

import { IntegrationUploadOptionsByIntegration, IntegrationActionResult, IntegrationActionResultType } from "@/types/integration"

import vSelect from "vue-select"

import api from "@/services/api"
import integrationApi from "@/services/api_Integrations"

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class IntegrationFileUpload extends Vue {
	@Prop()
	public fileUploadOptions!: IntegrationUploadOptionsByIntegration[] | null

	uploadOption!: IntegrationUploadOptionsByIntegration | null

	uploading = false
	dragging = false
	filesUploading = 0

	fileResults: { [key: string]: IntegrationActionResult } = {}
	private uploadError: any = null

	get resultFiles (): string[] {
		return Object.keys(this.fileResults)
	}

	private async uploadFiles (event: any): Promise<void> {
		this.dragging = false
		this.uploadError = null
		this.fileResults = {}

		const option = this.fileUploadOptions![0]!

		try {
			let files = event && event.target ? (event.target.files || (event.dataTransfer ? event.dataTransfer.files : [])) as any[] : []

			const fileList: File[] = []
			files.forEach((file: File) => fileList.push(file))
			this.filesUploading = files.length

			this.uploading = true
			await Promise.all(fileList.map((file: File) => this.uploadFile(option, file)))

			this.$emit("uploaded")
		} catch (ex) {
			this.uploadError = ex
		}

		event.srcElement.value = null
		this.uploading = false
	}

	async uploadFile (option: IntegrationUploadOptionsByIntegration, file: File) {
		return integrationApi.uploadIntegrationFile(option.integrationKey, option.uploadKey, file)
			.then((result) => {
				Vue.set(this.fileResults, file.name, result)
			})
			.catch((error) => {
				Vue.set(this.fileResults, file.name, {
					result: IntegrationActionResultType.Fail,
					errorMessages: [ error ]
				})
			})
	}
}
